import ValidateService from "@/helpers/services/qualitycontrol/validate.service";
import Notify from "@/helpers/notify";

const Apexchart = {
  settings(id = "apexchart", showToolbar = true) {
    return {
      states: {
        active: {
          allowMultipleDataPointsSelection: false         
        },
      },
      chart: {
        id: id,
        type:"bar",
        events: {
          dataPointSelection: (e, chart, opts) => {
            // Using toggling... not optimal code, should be changed...
            ApexCharts.exec("apexchart", "toggleSeries", "observationid");
            const observationid = opts.w.globals.series[0][opts.dataPointIndex];
            ApexCharts.exec("apexchart", "toggleSeries", "observationid");
            const rowsToValidate = [];     
            rowsToValidate.push({ id: observationid, flag: -1, index: 0 });
            
            (async () => {
              const rowsAffected = await ValidateService.validate(rowsToValidate);
              if (rowsAffected.validated != 1) {
                Notify.error("Could not update flag! Check verification flag");
              }
              else { 
              }
            })();
          }
        },
        toolbar: {
          show: showToolbar, 
          tools: {
            download: false,
            selection: true,
            zoom: true,
            zoomin: false,
            zoomout: false,
            pan: true,
          },
          autoSelected: 'pan'
        },
        animations: {
          enabled: false,
          animateGradually: {
            enabled: false
          },
          dynamicAnimation: {
            enabled: false
          }
        }
      },
      legend: {
        show: false
      },
      theme: {
        palette: "palette3"
      },
      xaxis: {
        type: "datetime"
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        curve: "straight",
        lineCap: "butt",
        width: 2,
        dashArray: 0
      },
      tooltip: {
        enabled: false
      }
    } 
  }   
}

export default Apexchart;